import { render, staticRenderFns } from "./AcademyStudentsSystemChartProgress.vue?vue&type=template&id=4aeee27f&scoped=true&lang=pug&"
import script from "./AcademyStudentsSystemChartProgress.vue?vue&type=script&lang=ts&"
export * from "./AcademyStudentsSystemChartProgress.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeee27f",
  null
  
)

export default component.exports